import type { ConsentService } from './types'
import { hotjarService } from './services/hotjar'

export const consentServices: ConsentService[] = [
  hotjarService,
]
